export const loanPurposeListItem = ["Medical Emergency", "Salary Delay", "Personal Emergency", "Education", "Rent / Bills", "Others"];

export const ORDER_ID_LOCAL_STORAGE_KEY =  'orderId';

export const START_FINBOX_FLOW_LOCAL_KEY = "start_finbox_flow";

export const MONTH_12_FLAGS_STATUS = {
  APPROVED: "Approved",
  NOT_ELIGIBLE: "Not Eligible",
  PROCEED_TO_BANK: "Proceed to Bank",
};
